<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <div class="item">
          <span class="label">{{ $t('decision.time') }}</span>
          <el-date-picker class="inp" v-model="formData.valTime" value-format="YYYY-MM-DD" size="small" type="daterange"
            unlink-panels :range-separator="$t('g.to')" :start-placeholder="$t('g.start_date')"
            :end-placeholder="$t('g.end_date')" :shortcuts="render.shortcuts">
          </el-date-picker>
        </div>
        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.CodePathID"
            :props="formData.props" :options="render.cascade_options_direct" />
        </div>
        <div class="item">
          <span class="label">{{ $t('member.status') }}</span>
          <el-select class="inp" size="small" v-model="formData.valStatus" :placeholder="$t('g.choose')">
            <el-option v-for="item in render.statuses" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="label">{{ $t('batteryFault.batteryId') }}</span>
          <el-input class="inp" size="small" v-model="formData.valBatteryId"
            :placeholder="$t('batteryFault.batteryId')"></el-input>
        </div>
      </div>
      <div class="btn-ct">
        <el-button @click="func.exportAllExcel(0)" class="btn-export" type="info">{{ $t('g.export')
        }}</el-button>
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table :data="formData.tableData" style="width: 100%" @row-click="func.showDetails">
        <el-table-column prop="Id" label="ID" width="100" v-if="!isOperator()">
        </el-table-column>

        <el-table-column prop="AgentCode" :label="$t('g.agent_code')" width="80">
        </el-table-column>
        <el-table-column prop="BatId" width="200" :label="$t('batteryFault.batteryId')">
        </el-table-column>
        <el-table-column prop="DevId" width="250" :label="$t('workOrder.cabinet_ID')">
        </el-table-column>
        <el-table-column prop="SlotId" width="60" :label="$t('device.slot_no')">
        </el-table-column>
        <el-table-column prop="StartAtStr" width="200" :label="$t('batteryFault.startTime')">
        </el-table-column>
        <el-table-column prop="EndAtStr" width="200" :label="$t('batteryFault.endTime')">
        </el-table-column>
        <el-table-column prop="UpdateNum" width="100" :label="$t('batteryFault.updateTimes')">
        </el-table-column>
        <el-table-column prop="AlertType" width="130" :label="$t('batteryFault.faultType')" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="UpType" width="130" :label="$t('batteryFault.updateType')">
        </el-table-column>
        <el-table-column prop="Status" width="130" :label="$t('batteryFault.status')">
        </el-table-column>
        <el-table-column prop="Remark" width="80" :label="$t('order.remark')" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="CodePath" min-width="180" :label="$t('g.operator_ownership')"
          :show-overflow-tooltip='true'>
        </el-table-column>
        <!-- <el-table-column prop="CreatedAtStr" width="200" :label="$t('g.create_at')">
        </el-table-column> -->
        <el-table-column prop="UpdatedAtStr" width="200" :label="$t('g.update_at')">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <div class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize }}
        </div>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <!-- <div class="pagination">
      <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
        :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
      </el-pagination>
    </div> -->
    <el-dialog :title="$t('g.detail')" v-model="formData.dialogDisplayVisible" style="width: 90%;" align-center>
      <el-descriptions border column="4">
        <el-descriptions-item :label="$t('Id')">{{ formData.curData.Id }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.agent_code')">{{ formData.curData.AgentCode
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('batteryFault.batteryId')">
          <el-link type="primary" @click="formData.batDrawerVisible = true">{{ formData.curData.BatId
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('workOrder.cabinet_ID')">
          <el-link type="primary" @click="formData.devDrawerVisible = true">{{ formData.curData.DevId
          }}</el-link>
        </el-descriptions-item>
        <el-descriptions-item :label="$t('device.slot_no')">{{ formData.curData.SlotId
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('batteryFault.startTime')">{{ formData.curData.StartAtStr
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('batteryFault.endTime')">{{ formData.curData.EndAtStr
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('batteryFault.updateTimes')">{{ formData.curData.UpdateNum
        }}</el-descriptions-item>

        <el-descriptions-item :label="$t('batteryFault.updateType')">{{ formData.curData.UpType
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('batteryFault.status')">{{ formData.curData.Status
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('order.remark')">{{ formData.curData.Remark
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.operator_ownership')">{{ formData.curData.CodePath }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.update_at')">{{ formData.curData.UpdatedAtStr }}</el-descriptions-item>
        <el-descriptions-item></el-descriptions-item>
        <el-descriptions-item></el-descriptions-item>
        <el-descriptions-item></el-descriptions-item>
        <el-descriptions-item :label="$t('batteryFault.faultType')">{{ formData.curData.AlertType
        }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-drawer v-model="formData.devDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <EboxList :propId="formData.curData.DevId"></EboxList>
    </el-drawer>
    <el-drawer v-model="formData.batDrawerVisible" size="80%" :with-header="true" :destroy-on-close="true"
      :title="$t('g.detail')">
      <BatteryList :propId="formData.curData.BatId"></BatteryList>
    </el-drawer>
  </div>
</template>

<script>
import { dayjs, ElLoading } from 'element-plus'
import { reactive, onMounted } from 'vue'
import axios from 'axios'
import { operators, updateOperators, shortcuts, cascade_options_direct } from '@/data/default'
import { toDay } from "@/common/func"
import i18n from '@/data/i18n/index'
import { isOperator } from '@/data/token'
import * as XLSX from 'xlsx/xlsx.mjs'
import EboxList from '@/views/ebox/list.vue'
import BatteryList from '@/views/battery/list.vue'

export default {
  name: 'OrderCabinet',
  components: {
    EboxList,
    BatteryList,
  },
  setup() {
    const t = i18n.global.t
    const tableData = []
    const statuses = [
      {
        label: t('member.statuses.all'),
        value: -1
      },

      {
        label: '故障中',
        value: '故障中',
      },
      {
        label: '故障结束',
        value: '故障结束',
      },
    ]

    const render = {
      shortcuts,
      statuses,
      operators,
      cascade_options_direct
    }
    const formData = reactive({
      tableData,
      curData: {},
      CodePathID: 0,
      valStatus: -1,
      valTime: '',
      valTel: '',
      idName: '',
      valOrderSn: '',
      valDeviceId: '',
      valFailReason: '',
      dialogDisplayVisible: false,
      devDrawerVisible: false,
      batDrawerVisible: false,
      // pagination
      curPage: 1,
      pageSize: 10,
      total: 1,
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "Id",
        emitPath: false,
        checkStrictly: true
      },
      IsStartWith: 1
    })
    const func = {
      showDetails(row) {
        formData.dialogDisplayVisible = true;
        formData.curData = row;
        formData.curData.eboxEvent = []
      },
      async exportAllExcel(type = 1) {
        let params = {
        }

        if (formData.CodePathID) {
          params.CodePathID = formData.CodePathID
        }
        if (formData.valBatteryId) {
          params.BatId = formData.valBatteryId
        }
        if (formData.valStatus != -1) {
          params.status = formData.valStatus
        }
        if (formData.valTime) {
          params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
          params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
        }
        params.IsStartWith = formData.IsStartWith

        params.getAll = 1
        let loading = ''
        loading = ElLoading.service({
          lock: true,
          text: t('openSlotsLit.loading'),
          background: 'rgba(0, 0, 0, 0.7)',
        })
        let res = await axios.get(`/admin/battery/getalert`, {
          params
        })
        let excleData = [[]];
        let wscols = [];
        excleData = [[
          'ID',
          t('openSlotsLit.agent_code'),
          '电池Id',
          '机柜Id',
          '仓号',
          '开始时间',
          '结束时间',
          '更新次数',
          '故障类型',
          '上传类型',
          '状态',
          '备注',
          '更新时间',
        ]];
        wscols = [    // 每列不同宽度px
          { wch: 10 },
          { wch: 10 },
          { wch: 25 },
          { wch: 25 },
          { wch: 12 },
          { wch: 24 },
          { wch: 24 },
          { wch: 10 },
          { wch: 30 },
          { wch: 12 },
          { wch: 10 },
          { wch: 8 },
          { wch: 24 },
        ];

        if (res && res.List) {
          for (let item of res.List) {
            let arr = [];
            arr = [
              item.Id,
              item.AgentCode,
              item.BatId,
              item.DevId,
              item.SlotId,
              item.CreateAt ? toDay(item.CreateAt) : '',
              item.EndTime ? toDay(item.EndTime) : '',
              item.UpdateNum,
              item.AlertType,
              item.UpType,
              item.Status,
              item.Remark,
              item.UpdateAt ? toDay(item.UpdateAt) : '',
            ]

            excleData.push(arr)
          }
        }

        const worksheet = XLSX.utils.aoa_to_sheet(excleData);
        worksheet["!cols"] = wscols;
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        loading.close()
        XLSX.writeFile(workbook, '电池故障信息' + '.xlsx');
      },

      search() {
        console.log('formData', formData)
        func.loadData(1)
      },
      pageChange(val) {
        console.log('page change', val)
        func.loadData(val)
      },
      refresh() {
        formData.CodePathID = 0
        formData.valStatus = -1
        formData.valTime = ''
        formData.valTel = ''
        formData.idName = ''
        func.loadData(1)
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page
          let params = {
            page,
          }
          if (formData.CodePathID) {
            params.CodePathID = formData.CodePathID
          }
          if (formData.valBatteryId) {
            params.BatId = formData.valBatteryId
          }
          if (formData.valStatus != -1) {
            params.status = formData.valStatus
          }
          if (formData.valTime) {
            params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
            params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
          }
          params.IsStartWith = formData.IsStartWith
          let res = await axios.get(`/admin/battery/getalert`, {
            params
          })
          formData.total = res.Total
          res.List.map((item) => {
            item.CreatedAtStr = toDay(item.CreatedAt)
            item.UpdatedAtStr = item.UpdateAt ? toDay(item.UpdateAt) : ''
            item.StartAtStr = item.CreateAt ? toDay(item.CreateAt) : ''
            item.EndAtStr = item.EndTime ? toDay(item.EndTime) : ''
            switch (item.SpendStatus) {
              case 0:
                item.SpendStatusStr = t('chart.order_statuses.doing')
                break
              case 1:
                item.SpendStatusStr = t('lowSales.end')
                break
              case 2:
                item.SpendStatusStr = t('lowSales.error')
              case 3:
                item.SpendStatusStr = t('lowSales.end2')
                break
            }

          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }
    onMounted(() => {
      console.log("onMounted")
      //updateOperators()
      func.loadData()
    })
    return {
      func,
      render,
      formData,
      isOperator,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  padding: 1.25rem 1.25rem 0 1.25rem;

  .inp-block {
    display: block;
  }

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    margin-bottom: 1.25rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

    >.btn-ct {
      text-align: right;
      margin-top: 12px;

      >.search1 {
        background-color: #14b2ec;
        color: #fff;
        border: 1px solid #14b2ec;
      }

      >.search2 {
        background-color: #048cbe;
        color: #fff;
        border: 1px solid #048cbe;
      }

      >.search3 {
        background-color: #ee8094;
        color: #fff;
        border: 1px solid #ee8094;
      }

      >.search4 {
        background-color: #bdb2b5;
        color: #fff;
        border: 1px solid #bdb2b5;
      }

      :deep(.el-button--small) {
        padding: 0.625rem 2rem;
      }
    }

    .inp-list {
      display: grid;
      margin: 0 auto;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 24.1%);
      gap: 14px 16px;

      >.item {
        display: flex;
        align-items: center;
        // justify-content: left;

        .label {
          display: flex;
          justify-content: left;
          // margin-right: 0.325rem;
          // margin-left: 0.3rem;
          min-width: 76px;
        }

        :deep(.el-range-editor--small.el-input__inner) {
          flex: 1;
        }

        .inp {
          flex: 1;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  // >.data-table {
  //   :deep(.el-table) {
  //     .cell {
  //       white-space: nowrap;
  //       text-overflow: ellipsis;
  //     }

  //     .el-table__row {
  //       cursor: pointer;
  //     }
  //   }
  // }

  .pagination {
    // text-align: right;
    margin-top: 1.25rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.25rem;

    .title {
      color: rgba(0, 0, 0, 0.6);
    }
  }

  .el-form-row {
    display: flex;
    justify-content: space-between;

    :deep(.el-form-item) {
      width: 49%;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }

  .dlg-bottom {
    display: flex;
    justify-content: space-around;
  }
}

.line {
  height: 1px;
  width: 100%;
  background-color: #e2e2e2;
  margin-top: 15px;
  margin-bottom: 15px;
}

@media screen and (max-width:1300px) {
  .content {
    >.card-box {
      .inp-list {
        grid-template-columns: repeat(3, 32.2%);
      }
    }
  }
}

@media screen and (max-width:1030px) {
  .content {
    >.card-box {
      .inp-list {
        grid-template-columns: repeat(2, 48.8%);
      }
    }
  }
}

@media screen and (max-width:792px) {
  .content {
    >.card-box {
      .inp-list {
        grid-template-columns: repeat(1, 100%);
      }
    }
  }
}
</style>
<!-- 

-->
